import type { CustomIconProps } from '../types';

const TriangleFilled = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '13'}
        viewBox="0 0 16 13"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.07858 0.925488C6.92474 -0.290317 8.7161 -0.312044 9.5915 0.882882L15.5789 9.05563C16.6235 10.4815 15.6052 12.4898 13.8376 12.4898H2.16226C0.418634 12.4898 -0.605445 10.5294 0.390586 9.09823L6.07858 0.925488Z"
            fill="#414042"
        />
    </svg>
);

export default TriangleFilled;
